export enum PaymentType {
  All = "All",
  ACH = "ACH",
  Check = "Check",
  NoPayment = "No Payment"
}
